<template>
  <v-container id="error-page">
    <v-img
      id="error-img"
      class="mx-auto"
      :src="getImage('/others/404.png')"
      :max-height="imageHeight"
      :max-width="imageWidth"
      contain
    ></v-img>
    <div
      id="error-title"
      class="text-center"
      :class="{'display-1' : $vuetify.breakpoint.mdAndUp, 'title' : $vuetify.breakpoint.smAndDown}"
    >Sorry! The page you were looking for could not be found</div>
    <div id="error-content" class="text-center subtitle-1">
      You Have Been Tricked Into Click On A Link That Can Not Be found
      <br />Please Check The URL Or Go To
      <a id="error-main-page" href="/">Main Page</a> And See If You Can Locate What You Are Looking For
    </div>
  </v-container>
</template>

<script>
import breakpointMixins from '../mixins/breakpointMixins'
import {getImage} from "../api/dataFactory"
export default {
  mixins : [breakpointMixins],
  data : () => ({
    getImage
  }),
  computed: {
    imageHeight() {
      let height = "200px";
      if(this.isSmAndDownViewport) {
        height = "100px";
      }
      return height;
    },
    imageWidth() {
      let width = "300px";
      if(this.isSmAndDownViewport) {
        width = "200px";
      }
      return width;
    }
  }
};
</script>
<style>
#error-img {
  padding-top: 10%;
}

#error-content {
  margin-top: 5%;
}

#error-page {
  margin-top: 100px;
  margin-bottom: 100px;
}
#error-main-page {
  color: red;
  text-decoration: none;
}
</style>